<unity-page-container [contentHeader]="$contentHeader()" [isLoading]="$resourceLoading()">
  <ng-container page-return> <unity-action-shared [action]="returnToDashboardAction" /></ng-container>

  <ng-container notifications>
    @if (this.$isDisabled()) {
      <unity-banner-alert-shared icon="infoSolidIcon">
        <div>This Program is in a 'Disabled' state, no new Agreements can be created for this Program.</div>
        <div>Any 'Active' Agreements associated with this Program can still be worked on.</div>
      </unity-banner-alert-shared>
    }
  </ng-container>

  <ng-container actions>
    <unity-workflow-selector-shared
      [transitions]="$availableTransitions()"
      [disabled]="$workflowActionsDisabled()"
      (workflowEvent)="onWorkflow($event)" />
    <unity-action-delete-shared
      *unityAuthorize="deleteEntitlement"
      [disabled]="$workflowActionsDisabled()"
      [buttonText]="`Delete ${resourceName}`"
      [confirmationTitle]="`Confirm Delete ${resourceName}?`"
      [confirmationMessage]="`Are you sure you want to delete this ${resourceName}?`"
      (deleteEvent)="onDelete()" />
  </ng-container>

  @let formGroup = $formGroup();
  <unity-panel-manage-shared
    [resource]="$resource()"
    [resourceName]="resourceName"
    [formGroup]="formGroup"
    [isEditable]="$isEntitledToEdit()"
    [submitLoading]="$updateLoading()"
    (saveEvent)="onSave()"
    (detailEditEvent)="toggleWorkflowActions($event)">
    <unity-form-layout>
      <unity-textbox-control displayName="Name" description="Provide a name." [control]="formGroup.controls.name" />
      <unity-textbox-control displayName="Code" description="Provide a code." [control]="formGroup.controls.code" />
    </unity-form-layout>
  </unity-panel-manage-shared>
</unity-page-container>
